<template>
  <div>
    <div v-loading="loading">
      <main>
        <!-- 轮播 -->
        <div class="swiper">
          <div
            class="swiperBox"
            id="swiper"
            :style="{ height: scrollerHeight }"
          >
            <el-carousel>
              <el-carousel-item v-for="(item, index) in ppttrack" :key="index">
                <template v-if="item.type == 2">
                  <a :href="item.url" target="_blank">
                    <img
                      class="bannImage"
                      :src="item.image"
                      alt=""
                      @click="addUrl(item)"
                      v-if="index === 0"
                      ref="imagBox"
                      @load="onImageLoad"
                    />
                    <img
                      class="bannImage"
                      :src="item.image"
                      alt=""
                      @click="addUrl(item)"
                      v-else
                    />
                  </a>
                </template>
                <template v-else>
                  <img
                    class="bannImage"
                    :src="item.image"
                    alt=""
                    @click="addUrl(item)"
                    v-if="index === 0"
                    ref="imagBox"
                    @load="onImageLoad"
                  />
                  <img
                    class="bannImage"
                    :src="item.image"
                    alt=""
                    @click="addUrl(item)"
                    v-else
                  />
                </template>
              </el-carousel-item>
            </el-carousel>
          </div>
        </div>
        <div class="CompetitionEntrance">
          <div 
            :class="{ 
              'module-no-permission': !hasInternetPlusPermission && hasAnyModulePermission,
              'module-grayed': showMaterialMask && !hasInternetPlusPermission && hasAnyModulePermission
            }"
            @click="handleMaterialClick"
            @mouseenter="handleMaterialHover"
            @mouseleave="handleMaterialLeave"
          >
            <img src="../../assets/cxds.png" alt="" />
            <h2>大学生创新大赛备赛素材</h2>
            <p>
              依据最新赛事规则，由近百位具有丰富国赛金奖材料服务经验的设计师共同打造，专注高教、职教、红旅三大重点赛道各组别，使项目备赛BP（Word、PPT、VCR）材料高效呈现，助力参赛团队在创新大赛赛事中取得更好成绩。
            </p>
            <button>下载素材</button>
          </div>
          <div 
            :class="{ 
              'module-no-permission': !hasXinWenKePermission && hasAnyModulePermission,
              'module-grayed': showXinWenKeMask && !hasXinWenKePermission && hasAnyModulePermission
            }"
            @click="handleXinWenKeClick"
            @mouseenter="handleXinWenKeHover"
            @mouseleave="handleXinWenKeLeave"
          >
            <img src="../../assets/xwk_tittle1.png" alt="" />
            <h2>新文科实践创新大赛备赛素材</h2>
            <p>
              深贴合大学生新文科实践创新大赛最新赛制，由数十位深耕新文科教育与竞赛指导的专家联合研发，聚焦文史哲、经管法、教育艺术四大核心组别，打造专属备赛 BP 模板，帮助参赛团队快速梳理项目内容，高效输出符合赛事标准的材料。
            </p>
            <button>下载素材</button>
          </div>
          <div 
            :class="{ 
              'module-no-permission': !hasCareerPermission && hasAnyModulePermission,
              'module-grayed': showCareerMask && !hasCareerPermission && hasAnyModulePermission
            }"
            @click="handleCareerClick"
            @mouseenter="handleCareerHover"
            @mouseleave="handleCareerLeave"
          >
            <img src="../../assets/zhiguisai.png" alt="" />
            <h2>大学生职业规划大赛备赛素材</h2>
            <p>
              筑梦青春志在四方、规划启航指引未来。为备赛团队提供专业资料素材服务，成就首届大赛参赛者，敬请期待。+”赛事中取得更好成绩。
            </p>
            <button>下载素材</button>
          </div>
          <div 
            :class="{ 
              'module-no-permission': !hasBigChallengePermission && hasAnyModulePermission,
              'module-grayed': showBigChallengeMask && !hasBigChallengePermission && hasAnyModulePermission
            }"
            @click="handleBigChallengeClick"
            @mouseenter="handleBigChallengeHover"
            @mouseleave="handleBigChallengeLeave"
          >
            <img src="../../assets/datiao.png" alt="" />
            <h2>（大挑）大学生课外学术科技作品竞赛备赛素材</h2>
            <p>
              "大挑战杯"依据最新赛制规则，由资深竞赛指导专家团队联合打造，聚焦科技发明制作、自然科学论文、哲学社会科学调研报告等核心类别，助力参赛团队高效备赛，在挑战杯赛事中脱颖而出。
            </p>
            <button>下载素材</button>
          </div>
          <div 
            :class="{ 
              'module-no-permission': !hasSmallChallengePermission && hasAnyModulePermission,
              'module-grayed': showSmallChallengeMask && !hasSmallChallengePermission && hasAnyModulePermission
            }"
            @click="handleSmallChallengeClick"
            @mouseenter="handleSmallChallengeHover"
            @mouseleave="handleSmallChallengeLeave"
          >
            <img src="../../assets/xiaotiao.png" alt="" />
            <h2>（小挑）大学生创业计划竞赛备赛素材</h2>
            <p>
              "小挑战杯"紧贴最新赛制要求，由资深创业竞赛指导专家团队精心研发，聚焦科技创新、乡村振兴、社会治理等核心赛道，打造专属备赛BP模板，助力参赛团队在创业计划竞赛中取得优异成绩。
            </p>
            <button>下载素材</button>
          </div>
        </div>
      </main>
    </div>
  </div>
</template>
<script>
// ,mapMutations
import { mapState, mapMutations } from "vuex";
import permissionManager from "@/utils/ecardPermissionManager";
import API from "@/api/api";

export default {
  data() {
    return {
      ppttrack: [],
      screenWidth: document.body.clientWidth,
      scrollerHeight: "350px", // 默认高度
      loading: false,
      // 模块权限状态
      hasInternetPlusPermission: false,  // 互联网+模块权限（模块标识1）
      hasXinWenKePermission: false,       // 新文科模块权限（模块标识8）
      hasCareerPermission: false,         // 职规赛模块权限（模块标识4-7）
      hasBigChallengePermission: false,    // 大挑战杯模块权限（模块标识2）
      hasSmallChallengePermission: false,  // 小挑战杯模块权限（模块标识3）
      hasAnyModulePermission: false,      // 是否有任何模块权限
      modulePermissionsLoading: false,     // 权限加载中
      // 遮罩层显示状态
      showMaterialMask: false,             // 互联网+模块遮罩
      showXinWenKeMask: false,             // 新文科模块遮罩
      showCareerMask: false,               // 职规赛模块遮罩
      showBigChallengeMask: false,         // 大挑战杯模块遮罩
      showSmallChallengeMask: false        // 小挑战杯模块遮罩
    };
  },
  computed: {
    ...mapState(["nav", "token"])
  },
  //  方法
  methods: {
    getapp() {
      this.loading = true;
      //获取轮播图
      this.axios
        .indexAd({})
        .then(res => {
          if (res.data.code == 200) {
            this.ppttrack = res.data.data;
          } else {
            this.ppttrack = [];
          }
        })
        .catch(err => {
          this.$message.error("轮播图加载失败");
        });
      this.axios
        .indexPage({})
        .then(res => {
          if (res.data.code == 200) {
            this.artiList = res.data.data.ppt;
            this.wordList = res.data.data.word;
          }
        })
        .catch(err => {
          this.$message.error("首页内容加载失败");
        })
        .finally(() => {
          this.loading = false;
        });
    },
    swiperBox() {
      this.$nextTick(() => {
        let img = this.$refs.imagBox;
        if (Array.isArray(img)) {
          img = img[0];
        }
        if (img && img.offsetHeight) {
          this.scrollerHeight = img.offsetHeight + "px";
        }
      });
    },
    onImageLoad() {
      this.swiperBox();
    },
    // 获取用户模块权限
    async getUserModulePermissions() {
      // 如果用户未登录，不检查权限
      if (!this.$store.state.token) {
        this.hasInternetPlusPermission = true;
        this.hasXinWenKePermission = true;
        this.hasCareerPermission = true;
        this.hasBigChallengePermission = true;
        this.hasSmallChallengePermission = true;
        this.hasAnyModulePermission = false;
        return;
      }

      try {
        this.modulePermissionsLoading = true;
        const permissions = await permissionManager.getUserBoundModules(this.$store.state.token);
        
        const boundModules = permissions.boundModuleMarks || [];
        
        // 检查互联网+模块权限（模块标识1）
        this.hasInternetPlusPermission = boundModules.includes(1);
        
        // 检查新文科模块权限（模块标识8）
        this.hasXinWenKePermission = boundModules.includes(8);
        
        // 检查职规赛模块权限（模块标识4-7，任意一个即可）
        this.hasCareerPermission = boundModules.some(mark => mark >= 4 && mark <= 7);
        
        // 检查大挑战杯模块权限（模块标识2）
        this.hasBigChallengePermission = boundModules.includes(2);
        
        // 检查小挑战杯模块权限（模块标识3）
        this.hasSmallChallengePermission = boundModules.includes(3);
        
        // 检查是否有任何模块权限
        this.hasAnyModulePermission = boundModules.length > 0;
        
        // 如果用户有模块权限，但某个模块没有权限，则限制访问
        // 如果用户没有任何模块权限，则允许所有模块访问（未绑定会员的情况）
        if (this.hasAnyModulePermission) {
          // 用户已绑定模块权限，需要检查单个模块权限
        } else {
          // 用户未绑定任何模块权限，允许访问所有模块
          this.hasInternetPlusPermission = true;
          this.hasXinWenKePermission = true;
          this.hasCareerPermission = true;
          this.hasBigChallengePermission = true;
          this.hasSmallChallengePermission = true;
        }
      } catch (error) {
        console.error('获取模块权限失败:', error);
        // 出错时允许访问所有模块
        this.hasInternetPlusPermission = true;
        this.hasXinWenKePermission = true;
        this.hasCareerPermission = true;
        this.hasBigChallengePermission = true;
        this.hasSmallChallengePermission = true;
        this.hasAnyModulePermission = false;
      } finally {
        this.modulePermissionsLoading = false;
      }
    },
    
    // 处理互联网+模块悬停
    handleMaterialHover() {
      if (this.hasAnyModulePermission && !this.hasInternetPlusPermission) {
        this.showMaterialMask = true;
      }
    },
    
    // 处理互联网+模块离开
    handleMaterialLeave() {
      this.showMaterialMask = false;
    },
    
    // 处理互联网+模块点击
    async handleMaterialClick() {
      // 如果用户有模块权限绑定，需要检查权限
      if (this.hasAnyModulePermission && !this.hasInternetPlusPermission) {
        this.$message.warning('温馨提示：您暂无该模块权限，请绑定对应的会员权限后再试');
        return;
      }
      this.$router.push("/indexHome");
    },
    
    // 处理新文科模块悬停
    handleXinWenKeHover() {
      if (this.hasAnyModulePermission && !this.hasXinWenKePermission) {
        this.showXinWenKeMask = true;
      }
    },
    
    // 处理新文科模块离开
    handleXinWenKeLeave() {
      this.showXinWenKeMask = false;
    },
    
    // 处理新文科模块点击
    async handleXinWenKeClick() {
      // 如果用户有模块权限绑定，需要检查权限
      if (this.hasAnyModulePermission && !this.hasXinWenKePermission) {
        this.$message.warning('温馨提示：您暂无该模块权限，请绑定对应的会员权限后再试');
        return;
      }
      // 先检查模块是否有文件数据
      try {
        const response = await this.axios.getXinWenKeFiles({
          categoryId: null,
          subcategoryId: null,
          pageNum: 1,
          pageSize: 1,
          sort: "new"
        });
        const hasData = response.data.code === 200 && response.data.data &&
                       response.data.data.files && response.data.data.files.length > 0;
        if (!hasData) {
          this.$message.info('该模块待开放，敬请期待');
          return;
        }
      } catch (error) {
        // 如果接口出错，允许跳转
      }
      this.$router.push("/xinwenke");
    },
    
    // 处理职规赛模块悬停
    handleCareerHover() {
      if (this.hasAnyModulePermission && !this.hasCareerPermission) {
        this.showCareerMask = true;
      }
    },
    
    // 处理职规赛模块离开
    handleCareerLeave() {
      this.showCareerMask = false;
    },
    
    // 处理职规赛模块点击
    async handleCareerClick() {
      // 如果用户有模块权限绑定，需要检查权限
      if (this.hasAnyModulePermission && !this.hasCareerPermission) {
        this.$message.warning('温馨提示：您暂无该模块权限，请绑定对应的会员权限后再试');
        return;
      }
      this.$router.push("/competition");
    },
    
    // 处理大挑战杯模块悬停
    handleBigChallengeHover() {
      if (this.hasAnyModulePermission && !this.hasBigChallengePermission) {
        this.showBigChallengeMask = true;
      }
    },
    
    // 处理大挑战杯模块离开
    handleBigChallengeLeave() {
      this.showBigChallengeMask = false;
    },
    
    // 处理大挑战杯模块点击
    async handleBigChallengeClick() {
      // 如果用户有模块权限绑定，需要检查权限
      if (this.hasAnyModulePermission && !this.hasBigChallengePermission) {
        this.$message.warning('温馨提示：您暂无该模块权限，请绑定对应的会员权限后再试');
        return;
      }
      // 先检查模块是否有文件数据
      try {
        const response = await this.axios.datiaoPage({
          id: 0,
          pageNum: 1,
          pageSize: 1
        });
        const hasData = response.data.code === 200 && response.data.data &&
                       response.data.data.records && response.data.data.records.length > 0;
        if (!hasData) {
          this.$message.info('该模块待开放，敬请期待');
          return;
        }
      } catch (error) {
        // 如果接口出错，允许跳转
      }
      // 跳转到大挑页面
      this.$router.push("/bigchallenge");
    },
    
    // 处理小挑战杯模块悬停
    handleSmallChallengeHover() {
      if (this.hasAnyModulePermission && !this.hasSmallChallengePermission) {
        this.showSmallChallengeMask = true;
      }
    },
    
    // 处理小挑战杯模块离开
    handleSmallChallengeLeave() {
      this.showSmallChallengeMask = false;
    },
    
    // 处理小挑战杯模块点击
    async handleSmallChallengeClick() {
      // 如果用户有模块权限绑定，需要检查权限
      if (this.hasAnyModulePermission && !this.hasSmallChallengePermission) {
        this.$message.warning('温馨提示：您暂无该模块权限，请绑定对应的会员权限后再试');
        return;
      }
      // 先检查模块是否有文件数据
      try {
        const response = await API.xiaotiaoPage({
          id: 0,
          pageNum: 1,
          pageSize: 1
        });
        const hasData = response && response.data && (response.data.code === 200 || response.data.success === true) &&
                       response.data.data && response.data.data.records && response.data.data.records.length > 0;
        if (!hasData) {
          this.$message.info('该模块待开放，敬请期待');
          return;
        }
      } catch (error) {
        // 如果接口出错，允许跳转
      }
      // 跳转到小挑页面
      this.$router.push("/smallchallenge");
    },
    
    // 保留旧方法名以兼容（已废弃，使用新的handle方法）
    material() {
      this.handleMaterialClick();
    },
    Ultraman() {
      this.handleCareerClick();
    },
    xinwenke() {
      this.handleXinWenKeClick();
    },
    //跳转至详情页
    jump(val, item) {
      let link = this.$router.resolve({
        name: "Detailspage",
        query: { type: val, code: item.code }
      });
      window.open(link.href, "_blank");
    },
    ...mapMutations(["UP_BOOLE"])
  },
  watch: {
    screenWidth(val) {
      this.swiperBox();
    }
  },
  mounted() {
    this.UP_BOOLE();
    this.getapp();
    // 获取用户模块权限
    this.getUserModulePermissions();
    this.$nextTick(() => {
      setTimeout(() => {
        this.swiperBox();
      }, 1000);
    });
    const that = this;
    window.onresize = () => {
      return (() => {
        window.screenWidth = document.body.clientWidth;
        that.screenWidth = window.screenWidth;
      })();
    };
  }
};
</script>

<style>
* {
  font-size: 16px;
  user-select: none;
}

.sumWidth {
  /* width: 1400px; */
  margin: auto;
}

.flex-col {
  display: flex;
}

.header-navbar {
  height: 32px;
  justify-content: space-between;
  margin: 20px auto;
}

.swiper {
  /* min-width: 1400px; */
  position: relative;
}

.swiper img {
  width: 100%;
}

.CompetitionEntrance {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 40px 60px; /* 行间距40px，列间距60px */
  margin-top: 40px;
  margin-bottom: 40px;
  padding: 0 80px; /* 两边留白适中 */
}

.CompetitionEntrance > div {
  background: #fff;
  box-shadow: 0 0 20px 0 rgba(43, 42, 43, 0.12);
  border-radius: 12px;
  box-sizing: border-box;
  padding: 32px 24px 24px 24px;
  width: 420px;
  min-width: 320px;
  height: 480px;
  position: relative;
  cursor: pointer;
  margin: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: box-shadow 0.3s, border 0.3s;
  border: 2px solid transparent;
}

.CompetitionEntrance > div:hover {
  box-shadow: 0 8px 40px 0 rgba(43, 42, 43, 0.22);
  border: 2px solid #13a4e6;
}

.CompetitionEntrance img {
  width: 95%;
  height: 140px;
  object-fit: cover;
  border-radius: 8px;
}

.CompetitionEntrance h2 {
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  color: #222;
  margin-top: 24px;
  margin-bottom: 12px;
  text-align: center;
}

.CompetitionEntrance p {
  width: 100%;
  height: 90px;
  font-size: 15px;
  color: #666;
  line-height: 22px;
  margin-top: 0;
  margin-bottom: 24px;
  text-indent: 2rem;
  overflow: hidden;
  text-align: left;
}

.CompetitionEntrance button {
  width: 120px;
  height: 36px;
  background: linear-gradient(90deg, #28d4e1, #13a4e6);
  border-radius: 18px;
  border: 0;
  color: #fff;
  font-size: 15px;
  font-weight: 500;
  position: absolute;
  bottom: 28px;
  left: 50%;
  transform: translateX(-50%);
  transition: background 0.3s;
  box-shadow: 0 2px 8px rgba(20, 164, 230, 0.12);
}

.CompetitionEntrance > div:hover button {
  background: linear-gradient(90deg, #13a4e6, #28d4e1);
}

.CompetitionEntrance button:active {
  background: #13a4e6;
  box-shadow: none;
}

/* 无权限模块样式 - 默认保持原有样式不变 */
.CompetitionEntrance > div.module-no-permission {
  position: relative;
  cursor: pointer;
}

/* 微灰样式 - 悬停时应用，仅改变色差 */
.CompetitionEntrance > div.module-grayed {
  filter: brightness(0.95) grayscale(0.1);
  background-color: rgba(0, 0, 0, 0.07);
}

footer {
  text-align: center;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  margin-top: 33px;
}
</style>
<style>
.seamless-warp {
  height: 80px;
  margin-bottom: 17px;
  overflow: hidden;
}

.swiperBox .el-carousel__indicators {
  opacity: 0;
}

.swiperBox .el-carousel {
  width: 100%;
  overflow: hidden;
  height: 100%;
}

.swiperBox .el-carousel__container {
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
